import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../atoms'
import { Modal } from '../Modal'

interface ConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmLabel?: string
  isLoading?: boolean
}

export const ConfirmModal = memo(
  ({ isOpen, onClose, onConfirm, title, message, confirmLabel, isLoading }: ConfirmModalProps) => {
    const { t } = useTranslation('admin-mobifull')

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        footer={
          <div className="modal__footer-actions">
            <Button variant="ghost" onClick={onClose} disabled={isLoading}>
              {t('common.actions.cancel')}
            </Button>
            <Button variant="primary" onClick={onConfirm} isLoading={isLoading}>
              {confirmLabel ?? t('common.actions.confirm')}
            </Button>
          </div>
        }>
        <p className="modal__confirm-message">{message}</p>
      </Modal>
    )
  },
)

ConfirmModal.displayName = 'ConfirmModal'
